module.exports = __webpack_public_path__ + "img/icon-onboarding.2fc9c776.svg";